/**
 * Drum label codes, as Aufmass.Api/Inventory/DrumCode.cs: "MIH-" + 6 Crockford base32 characters
 * + 1 check character. Normalising here means a typed or scanned code opens the right drum
 * without a round trip, and a mistyped one is caught before it is looked up.
 */
const ALPHABET = '0123456789ABCDEFGHJKMNPQRSTVWXYZ'
const CHECK = ALPHABET + '*~$=U'

function check(body: string): string {
  // 32^6 < 2^31, so plain numbers are exact.
  let value = 0
  for (const c of body) value = value * 32 + ALPHABET.indexOf(c)
  return CHECK[value % 37]!
}

/** A typed, scanned or URL form → the canonical code, or null if it isn't one. */
export function normalizeDrumCode(input: string | null | undefined): string | null {
  if (!input) return null
  let s = input.trim()
  const slash = s.toLowerCase().lastIndexOf('/d/')
  if (slash >= 0) s = s.slice(slash + 3)
  s = s.toUpperCase().replace(/[\s-]/g, '')
  if (s.startsWith('MIH')) s = s.slice(3)
  if (s.length !== 7) return null
  const fix = (c: string) => (c === 'O' ? '0' : c === 'I' || c === 'L' ? '1' : c)
  const body = [...s.slice(0, 6)].map(fix).join('')
  if ([...body].some((c) => !ALPHABET.includes(c))) return null
  const c = fix(s[6]!)
  return check(body) === c ? `MIH-${body}${c}` : null
}

/** The address a label's QR encodes: any phone camera opens the drum page from it. */
export const drumUrl = (code: string) => `${window.location.origin}/d/${code}`
